import React, {useEffect, useState} from 'react';
import {useParams, Link} from 'react-router-dom'
import moment from "moment";
import "moment/locale/pl";
import ReactHtmlParser from "react-html-parser";

import BlogDataAccess from "../../utils/BlogDataAccess";
import BlogPostContent from "./BlogPostContent";
import BlogArticleCard from "./BlogArticleCard";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import goAutoLogo from "../../assets/images/content/logos/goauto_logo.svg";

const RELATED_POSTS_LIMIT = 4;

function BlogPost() {
    const {postLink} = useParams();

    const [blogDataAccess] = useState(new BlogDataAccess());
    const [morePosts, setMorePosts] = useState(null);
    const [post, setPost] = useState(null);

    const [previousMetaDescription] = useState(MetaTagsManipulator.getDescription())

    useEffect(() => {
        blogDataAccess.getPostByLink(postLink).then(setPost)

        return () => {
            MetaTagsManipulator.setDefaultTitle()
            MetaTagsManipulator.setDescription(previousMetaDescription)
        }
    }, [postLink])

    useEffect(() => {
        if(post){
            getMorePosts(post.tagNames)
            setPostMetaData(post)
        }
    }, [post])

    const setPostMetaData = (post) => {
        if(post.metaTitle) {
            MetaTagsManipulator.setTitle(post.metaTitle)
        }

        if(post.metaDescription) {
            MetaTagsManipulator.setDescription(post.metaDescription)
        }
    }

    const getMorePosts = (tagArray) => {
        let posts = new Array();

        tagArray.forEach(tag => {

            if(!morePosts || morePosts.length < 8) {

                blogDataAccess.getPostsByTagLimited(tag).then(postsByTag => {
                    posts = posts.concat(postsByTag.filter(iteratedPost => iteratedPost.id !== parseInt(post.id)));
                    setMorePosts(posts.slice(0, 8))
                })

            }

        })

        if(!morePosts || morePosts.length < 8) {

            blogDataAccess.getPostsByCategoryLimited(post.categoryName).then(postsByCategory => {
                if(!morePosts || morePosts.length < 8) {
                    posts = posts.concat(postsByCategory.filter(iteratedPost => iteratedPost.id !== parseInt(post.id)));
                    setMorePosts(posts.slice(0, 8))
                }
            })

        }

    }

    if (!post) return <div id="content"/>;

    const formattedDate = post.creationDate ? moment(post.creationDate).locale('pl').format('D MMMM YYYY') : '';
    const relatedPosts = morePosts ? morePosts.slice(0, RELATED_POSTS_LIMIT) : [];

    return (
        <div id="content">
            <div className="blog2-post-section">
                <div className="blog2-post-wrapper">
                    {formattedDate && <p className="blog2-post-date">{formattedDate}</p>}
                    <h1 className="blog2-post-title">{post.title}</h1>
                    {post.lead && <div className="blog2-post-lead">{ReactHtmlParser(post.lead)}</div>}
                    <img
                        src={post.backgroundUrl ? post.backgroundUrl : goAutoLogo}
                        alt=""
                        className="blog2-post-cover"
                    />
                </div>

                <div className="blog2-post-wrapper">
                    <BlogPostContent content={post.content}/>
                </div>

                {post.author && (
                    <div className="blog2-post-wrapper">
                        <div className="blog2-post-divider"/>
                        <div className="blog2-post-author">
                            <p className="blog2-post-author-label">autor</p>
                            <p className="blog2-post-author-name">{post.author}</p>
                        </div>
                    </div>
                )}

                {relatedPosts.length > 0 && (
                    <div className="blog2-post-related">
                        <h2 className="blog2-post-related-title">Polecamy również inne artykuły</h2>
                        <div className="blog2-post-related-grid">
                            {relatedPosts.map(relatedPost => (
                                <BlogArticleCard post={relatedPost} key={relatedPost.id}/>
                            ))}
                        </div>
                        {post.categoryLink && (
                            <Link to={`/blog/category/${post.categoryLink}`} className="blog2-post-related-btn">
                                zobacz wszystkie
                                <span className="blog2-post-related-btn-icon">›</span>
                            </Link>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default BlogPost;
